import {
  type Ref,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

import CheckoutSuccess from '@assets/success.json';
import { Button } from '@components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@components/ui/dialog';
import { pages } from '@constants/pages';
import { useAuth } from '@contexts/auth';
import SessionService from '@services/sessions/SessionService';
import Lottie from 'react-lottie';
import { useNavigate } from 'react-router';

export interface IRefProps {
  close(): void;
  open(): void;
}

interface IProps {
  ref: Ref<IRefProps>;
}

export function SuccessDialogAlert({ ref }: IProps) {
  const { onSetUser } = useAuth();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const lottieRef = useRef<any>(null);

  const handleTrigger = useCallback(() => {
    setIsOpen((oldState) => !oldState);
  }, []);

  const handleClose = useCallback(async () => {
    const userInfo = await SessionService.getInfo();
    onSetUser(userInfo);
    handleTrigger();
    navigate(pages.home, { replace: true });
  }, [handleTrigger, navigate, onSetUser]);

  useImperativeHandle(
    ref,
    () => ({
      open: () => {
        handleTrigger();
        setTimeout(() => {
          lottieRef.current?.play();
        }, 800);
      },
      close: () => {
        handleTrigger();
      },
    }),
    [handleTrigger],
  );
  return (
    <Dialog open={isOpen}>
      <DialogContent className="[&>button]:hidden">
        <DialogHeader>
          <DialogTitle className="text-primary text-center">
            Parabéns!
          </DialogTitle>
        </DialogHeader>
        <h1 className="text-center">
          Seu pagamento está em processamento e logo você terá acesso completo
          ao sistema
        </h1>
        <Lottie
          height={280}
          isClickToPauseDisabled={true}
          options={{
            animationData: CheckoutSuccess,
            loop: false,
            autoplay: false,
          }}
          ref={lottieRef}
          speed={0.7}
          title="Não foi possível carregar"
          width={280}
        />
        <DialogFooter className="sm:flex sm:flex-row sm:items-center sm:justify-center">
          <Button className="w-40 cursor-pointer" onClick={handleClose}>
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
